// extracted by mini-css-extract-plugin
export default {"ExperienceContainer":"Experience_ExperienceContainer__NgdA+","title":"Experience_title__vOa5O","ExperienceData":"Experience_ExperienceData__V8a-8"};